import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useTodoData } from '@/utils/hooks/useTodoData';

interface ITodoCountProps {
  orgId?: string;
}

const TodoCount = observer(({ orgId }: ITodoCountProps) => {
  const { fetchTodoData } = useTodoData();

  useEffect(() => {
    if (orgId) {
      fetchTodoData();
    }
  }, [orgId, fetchTodoData]);

  return null; // 这个组件不渲染任何内容，只负责更新store中的数据
});

export default TodoCount;
